import { IconType } from 'react-icons';

interface FilterIconProps {
    icon: IconType | string;
    size?: number;
    imgSize?: number;
    imgClassName?: string;
}

const FilterIcon = ({ icon: Icon, size = 20, imgSize = size, imgClassName = '' }: FilterIconProps) =>
    typeof Icon === 'string'
        ? <img src={Icon} style={{ width: imgSize, height: imgSize }} className={`shrink-0 ${imgClassName}`} alt='' />
        : <Icon size={size} className='shrink-0' />

export default FilterIcon
